import React from 'react';
import { useQuery } from "react-query";

import * as helpers from '../../utils/utils.js';
import "./slotTableRow.css"

import { usePrices } from '../../hooks/usePrices.js';
import { useUnits } from '../../hooks/useUnits.js';
import { useSlots } from '../../hooks/useSlots.js';

function SlotTableRow({ slotId, onSelect }) {
    const { retrieveSlotById } = useSlots();
    const { retrieveUnitById } = useUnits();
    const { retrievePriceById } = usePrices();

    const {
        data: slot,
        error: slotError,
        isLoading: slotIsLoading,
    } = useQuery(["slotData", slotId], () => retrieveSlotById(slotId), {
      staleTime: 1000 * 60 * 30, // optional: cache for 5 minutes{
      refetchOnWindowFocus: false,        // prevent re-fetch on tab switch
      cacheTime: 1000 * 60 * 60,  
    });
  
    const {
      data: unit,
      error: unitError,
      isLoading: unitIsLoading,
    } = useQuery(["unitData", slot?.unitId], () => retrieveUnitById(slot.unitId), {
      enabled: !!slot?.unitId,
      staleTime: 1000 * 60 * 30, // optional: cache for 5 minutes{
      refetchOnWindowFocus: false,        // prevent re-fetch on tab switch
      cacheTime: 1000 * 60 * 60,  
    });
  
    const {
      data: price,
      error: priceError,
      isLoading: priceIsLoading,
    } = useQuery(["priceData", slot?.priceId], () => retrievePriceById(slot.priceId), {
      enabled: !!slot?.priceId,
      staleTime: 1000 * 60 * 30, // optional: cache for 5 minutes{
      refetchOnWindowFocus: false,        // prevent re-fetch on tab switch
      cacheTime: 1000 * 60 * 60,  
    });
  
  
    if (slotIsLoading) return <td colSpan={5}>Loading slot...</td>;
    if (unitIsLoading || priceIsLoading) return <td colSpan={5}>Loading...</td>;
    if (slotError) return <td colSpan={5}>Error: {slotError.message}</td>;
    if (unitError) return <td colSpan={5}>Error: {unitError.message}</td>;
    if (priceError) return <td colSpan={5}>Error: {priceError.message}</td>;
  
    if (slot && unit && price) return (
      <>
        <td className='slot-image'><img src={unit.picture} alt="unit"/></td>
        <td className='unit'>{unit.name}</td>
        <td className='date'>{helpers.formatDate(slot.date)}</td>
        <td className='time'>{helpers.formatTimeRange(price.startTime.hours, price.startTime.minutes, price.duration)}</td>
        <td className='price'>${price.price}</td>
      </>
    );
}

export default SlotTableRow;